<template>
	<article :class="[componentClass, colorMode, {visible: visible, ready: ready}]">
		<div class="row">
			<div class="columns small-12 medium-10 medium-offset-1">
				<div class="row">
					<div class="small-12 medium-5 medium-offset-1 columns">
						<wysiwyg-content v-bind:data="data.wysiwyg_content" v-bind:columns="2"></wysiwyg-content>
					</div>
					<div class="small-12 medium-4 medium-offset-1 columns notes-list-wrapper">
						<h3 v-text="$t('notes')"></h3>
						<ul class="notes">
							<li>
								<overlay-link 
									v-for="(note, index) in data.notes"
									:ref="'note-' + index"
									:key="'note-' + index" 
									:model="note" 
									:requestPath="notesRequestPath"
									:index="'notes-' + index"></overlay-link>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</article>
</template>

<script>
import BaseBlock from './Base'
import WysiwygContent from './wysiwyg/Content'
import OverlayLink from '../../components/global/OverlayLinkAndContent'

export default {
	extends: BaseBlock,
	props: ['data'],
	data() {
		return {
			activeNote: false,
            defaultColorMode: 'light',
            componentClass: 'notes-outer-wrapper',
            initialNote: false
		}
	},
	computed: {
		notesRequestPath() {
			return window.dcSite.apiRoute + 'get/note/';
		}
	},
	methods: {
		getNoteData(key) {
			this.$http.get(window.dcSite.apiRoute + 'get/note/' + this.data.notes[key].id + '?lang=' + this.$store.state.lang).then(response => {
				if (response.data.success) {
					if (response.data.note) {
						this.activeNote = response.data.note;
					}
				}
			});

		},
		openNote(data) {
			var key = data.index;
			this.data.notes[key].selected = true;
			if (this.data.notes[key].selected) {
				this.getNoteData(key);
			} else {
				this.closeNote()
			}
		},
		closeNote() {
			this.activeNote = false;
			for (var i=0; i< this.data.notes.length; i++) {
				this.data.notes[i].selected = false;
			}
		},
		loadInitialNote() {
			if (
				typeof this.$route.params.note === 'undefined' || 
				document.body.classList.contains('overlay-open')
			) return;

			const noteNumber = this.$route.params.note - 1;
			const noteRef = 'note-' + noteNumber;
			if (typeof this.$refs[noteRef] !== 'undefined' && typeof this.$refs[noteRef][0].$refs.targetLink.click() === 'undefined') {
				window.setTimeout(() => {
					this.loadInitialNote();
				}, 200);
			}
		}
	},
	components: {
		WysiwygContent,
		OverlayLink,
	},
	mounted() {
		this.loadInitialNote();
	}
}
</script>

<style lang="scss">
	@import "../../styles/scss/global/block-wrapper";
	@import "../../styles/scss/component/text";
	@import "../../styles/scss/component/notes";
</style>